<div class="login-container">
  <!-- Left Panel (Illustration & Branding for Desktop/Tablets) -->
  <div class="left-panel">
    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png" alt="Logo 1">
      <img src="assets/dashboard icons/logo2.png" alt="Logo 2">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png" alt="Asha Saathi">
      <img src="assets/dashboard icons/logo4.png" alt="Logo 4">
      <img src="assets/dashboard icons/logo5.png" alt="Logo 5">
    </div>

    <div class="left-panel-text">
      {{ isMr
      ? 'मान्यताप्राप्त सामाजिक आरोग्य कार्यकर्त्या'
      : 'Accredited Social Health Activists' }}
    </div>

    <div class="left-panel-image-wrap">
      <img src="assets/dashboard icons/AshaPic.png" alt="Asha" class="left-hero-img" />
    </div>
  </div>

  <!-- Right Panel (OTP Form) -->
  <div class="right-container">
    <div class="login-card-wrapper">
      <!-- Mobile logos strip shown when left panel is hidden -->
      <div class="mobile-logos-bar">
        <img src="assets/dashboard icons/logo1.png" alt="Logo 1">
        <img src="assets/dashboard icons/logo2.png" alt="Logo 2">
        <img class="mobile-center-logo" src="assets/dashboard icons/ashasathilogo.png" alt="Asha Saathi">
        <img src="assets/dashboard icons/logo4.png" alt="Logo 4">
        <img src="assets/dashboard icons/logo5.png" alt="Logo 5">
      </div>

      <div class="login-card">
        <div class="login-header-icon-wrap">
          <img class="login-header-icon" src="assets/icons/headericon_pink.png" alt="Asha" />
        </div>

        <h2 class="login-title">
          {{ isMr ? 'ओटीपी पडताळणी' : 'OTP Verification' }}
        </h2>

        <p class="login-subtitle" style="line-height: 1.6;">
          {{ isMr
          ? '६ अंकी ओटीपी '
          : 'A 6-digit OTP has been sent to ' }}
          <b>{{ formData.EmailID }}</b>
          <br>
          {{ isMr
          ? 'वर पाठवण्यात आला आहे. पुढे जाण्यासाठी खाली कोड टाका'
          : 'Please enter the code below to continue' }}
        </p>

        <form class="login-form" (submit)="verifyotp()">
          <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top" class="custom-login-form"
            [showColonAfterLabel]="false">

            <dxi-form-item dataField="OTP" editorType="dxTextBox" [editorOptions]="{
                stylingMode: 'outlined',
                placeholder: isMr ? 'ओटीपी टाका' : 'Enter OTP',
                buttons: [{
                  name: 'userIcon',
                  id: 'OTP',
                  value: formData.OTP,
                  location: 'after',
                  options: { icon: 'custom-user-icon' }
                }]
              }">
            </dxi-form-item>
          </dx-form>

          <div class="otp-resend-block">
            <p class="otp-notice">
              {{ isMr ? 'कोड मिळाला नाही?' : "Didn't receive the code?" }}
            </p>
            <div class="forgot-password-text">
              <p *ngIf="isResendOtpDisabled" class="resend-timer-text">
                {{ isMr ? 'पुन्हा पाठवा ' : 'Resend in ' }}
                {{ ResendOtpTimer + (isMr ? ' सेकंद' : ' sec') }}
              </p>
              <a (click)="ResendOtp()" [style.cursor]="isResendOtpDisabled ? 'not-allowed' : 'pointer'"
                [class.disabled-link]="isResendOtpDisabled">
                {{ isMr ? 'पुन्हा पाठवा' : 'Resend Code' }}
              </a>
            </div>
          </div>

          <div class="login-action-wrap">
            <dx-button [text]="isMr ? 'ओटीपी सबमिट करा' : 'Submit OTP'" type="default" stylingMode="contained" class="login-button"
              (click)="verifyotp()"></dx-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>